import { Component, OnInit, Input } from '@angular/core';
import { PageInstructions } from '../page-utils';

@Component({
  selector: 'zc-page-render',
  template: `<zc-block-tree-node [widgetProperties]="widgetProperties" *ngIf="properties.instructions && properties.instructions.definition"
    [pageBlocks]="this.properties.instructions.definition.widgets"></zc-block-tree-node>`,
  styles: [``],
})
export class PageComponent implements OnInit {
  @Input() properties: any;
  @Input() widgetProperties: any; // baseUrl , client ,http,uid
  constructor() {
  }
  ngOnInit() {
    // console.log('widgetProperties', this.widgetProperties);
  }
}
